
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const TerrainPage = () => {
  const media = [
    '/images/terrain_2.webp', 
    '/images/terrain_3.webp', 
    '/images/terrain_4.webp'
    ];

  return (
    <div className="terrain-page">
      <ProjectTemplate
        title="terrain"
        year="2022"
        sections={[
          {
            type: "description",
            text: 'In terrain, interactions between sound and image set stage to a tale of landscapes. These landscape become unrecognisable, as they erupt into abstraction: Images of landscapes transform intoto 3-dimensional spaces, which in turn become their own landscapes. I see terrain as a collaboration between the materiality of the original landscapes, the binary logic of the computer and the neurological processes in the brain. In time, these understandings merge, influencing each other in feedback loops of thought, sound and image.',
          },
          {
            type: "video",
            links: [
                
              "https://www.youtube.com/embed/yTLij_s8NB0?si=ZxyNMUmu495PrLAFhowinfo=0&color=black&modestbranding=1&rel=0&mode=transparent&autohide=1&showinfo=0",
            ],
          },
          {
            type: "image",
            links: [
              {
                src: media[2]
              }
            ],
            isLink: false,
          },
      
          {
            type: "image", 
            links: [
              {
                src: media[1]
              }
            ], 
            isLink: false, 
          }, 
          {
            type: "image", 
            links: [
              {
                src: media[0]
              }
            ], 
            isLink: false, 
          }, 
        ]}
      />
    </div>
  );
};

export default TerrainPage;
